import React, { useEffect, useState } from 'react';

import { Link, useLocation } from 'react-router-dom';

import { Box, Grid, IconButton, Typography } from '@mui/material';

import { ReactComponent as BackIcon } from 'assets/icons/left.svg';

import { useGlobalApp } from 'hooks';

import Logo from './Logo';

import { getTitleFromPath } from './helpers';
import { useBackButton } from './hooks/useBackButton';

import { styles } from './styles';

const Header = () => {
  const location = useLocation();
  const { showBack, backUrl } = useBackButton();
  const { role } = useGlobalApp();

  const [title, setTitle] = useState('');

  useEffect(() => {
    const newTitle = getTitleFromPath(location.pathname, role);
    setTitle(newTitle);
  }, [location.pathname, role]);

  return (
    <Box pt={4} width={1}>
      <Grid container spacing={2} alignItems="center">
        {/* Back Icon */}
        <Grid item style={{ padding: 0 }}>
          {showBack && (
            <Box>
              <IconButton component={Link} to={backUrl} size={'small'}>
                <BackIcon />
              </IconButton>
            </Box>
          )}
        </Grid>
        {/* Title */}
        <Grid item xs>
          <Box>
            <Typography color="primary" sx={{ fontSize: '1.25rem' }}>
              {title}
            </Typography>
          </Box>
        </Grid>
        {/* Logo */}
        <Grid item sx={styles.logoContainer2}>
          <Logo />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Header;
